export default __webpack_public_path__ + "static/media/banner-mobile.a9d266e3.png";